// src/features/dashboard/services/Manager/productivityReport.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';
import { ENV } from '../../../../config/env';

import {
  ProductivityRequest,
  ProductivityKpiRequest,
  ProductivityKpiResponse,
  AssociateProductivityRequest,
  TeamProductivityResponse,
  ProductivityTrendResponse,
  AssociateProductivityResponse,
  ProductiveAppMixResponse,
  ProductivityDistributionResponse,
} from '../../types/Manager/productivityReport.types';

import {
  mockTeamProductivity,
  mockProductivityTrend,
  mockAssociateProductivity,
  mockProductiveAppMix,
  mockProductivityDistribution,
} from '../../mocks/Manager/productivityReport.mock';

/**
 * Productivity KPI Cards
 */
export const getProductivityKpiCards = async (
  request: ProductivityKpiRequest
): Promise<ProductivityKpiResponse> => {
  if (ENV.USE_MOCK) {
    return Promise.resolve({
      managerCode: 'SG375852',
      managerName: 'Manager',
      totalTeamLeads: 4,
      totalAssociates: 10,
      currentAvgProductivity: 66.25,
      aboveTargetCount: 0,
      belowTargetCount: 10,
      previousAvgProductivity: 0,
      productivityChange: 0,
      trend: 'NO CHANGE',
      topTeam: 'Top Team',
      topTeamProductivity: 70.4,
      lowestTeam: 'Lowest Team',
      lowestTeamProductivity: 62.8,
    });
  }

  const payload: ProductivityKpiRequest = {
    managerEmployeeCode: request.managerEmployeeCode,
    fromDate: request.fromDate,
    toDate: request.toDate,
    teamLeadEmployeeCode: request.teamLeadEmployeeCode,
  };

  try {
    console.log('==============================');
    console.log('Productivity KPI Cards Request');
    console.log(payload);
    console.log('==============================');

    const { data } = await api.post<ProductivityKpiResponse>(
      ENDPOINTS.PRODUCTIVITY_KPI_CARDS,
      payload
    );

    return data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return {
        managerCode: '',
        managerName: '',
        totalTeamLeads: 0,
        totalAssociates: 0,
        currentAvgProductivity: 0,
        aboveTargetCount: 0,
        belowTargetCount: 0,
        previousAvgProductivity: 0,
        productivityChange: 0,
        trend: 'NO DATA',
        topTeam: '',
        topTeamProductivity: 0,
        lowestTeam: '',
        lowestTeamProductivity: 0,
      };
    }

    console.error('Productivity KPI API Error:', error);
    throw error;
  }
};

/** Team Productivity */
export const getTeamProductivity = async (
  request: ProductivityRequest
): Promise<TeamProductivityResponse[]> => {
  if (ENV.USE_MOCK) return Promise.resolve(mockTeamProductivity);

  try {
    const { data } = await api.post<TeamProductivityResponse[]>(
      ENDPOINTS.PRODUCTIVITY_TEAM,
      request
    );
    return data ?? [];
  } catch (error: any) {
    if (error.response?.status === 404) return [];
    console.error('Team Productivity API Error:', error);
    throw error;
  }
};

/** WTD Trend */
export const getProductivityTrend = async (
  request: ProductivityRequest
): Promise<ProductivityTrendResponse[]> => {
  if (ENV.USE_MOCK) return Promise.resolve(mockProductivityTrend);

  try {
    const { data } = await api.post<ProductivityTrendResponse[]>(
      ENDPOINTS.PRODUCTIVITY_WTD_TREND,
      request
    );
    return data ?? [];
  } catch (error: any) {
    if (error.response?.status === 404) return [];
    console.error('Productivity Trend API Error:', error);
    throw error;
  }
};

/** Associate Productivity */
export const getAssociateProductivity = async (
  request: AssociateProductivityRequest
): Promise<AssociateProductivityResponse[]> => {
  if (ENV.USE_MOCK) return Promise.resolve(mockAssociateProductivity);

  try {
    const { data } = await api.post<AssociateProductivityResponse[]>(
      ENDPOINTS.PRODUCTIVITY_ASSOCIATE,
      request
    );
    return data ?? [];
  } catch (error: any) {
    if (error.response?.status === 404) return [];
    console.error('Associate Productivity API Error:', error);
    throw error;
  }
};

/** Productive App Mix */
export const getProductiveAppMix = async (
  request: ProductivityRequest
): Promise<ProductiveAppMixResponse[]> => {
  if (ENV.USE_MOCK) return Promise.resolve(mockProductiveAppMix);

  try {
    const { data } = await api.post<ProductiveAppMixResponse[]>(
      ENDPOINTS.PRODUCTIVITY_APP_MIX,
      request
    );
    return data ?? [];
  } catch (error: any) {
    if (error.response?.status === 404) return [];
    console.error('Productive App Mix API Error:', error);
    throw error;
  }
};

/** Productivity Distribution */
export const getProductivityDistribution = async (
  request: ProductivityRequest
): Promise<ProductivityDistributionResponse[]> => {
  if (ENV.USE_MOCK) return Promise.resolve(mockProductivityDistribution);

  try {
    const { data } = await api.post<ProductivityDistributionResponse[]>(
      ENDPOINTS.PRODUCTIVITY_DISTRIBUTION,
      request
    );
    return data ?? [];
  } catch (error: any) {
    if (error.response?.status === 404) return [];
    console.error('Productivity Distribution API Error:', error);
    throw error;
  }
};
